<template>
    <div>
        <div class="title">
            用户预约了今天 <span>{{detailInfo.appointmentTime}}</span> 时段，与 <span>{{detailInfo.organizationName}}</span> 进行远程问询，用户预约信息如下：
        </div>
        <div class="detail_case">
            <div class="detail_item">
                <b>驾驶证</b>
                <ul>
                    <li>姓名</li>
                    <li v-if="detailInfo.driverCardInfo">
                        <el-input placeholder="请输入" size="mini" v-model="detailInfo.driverCardInfo.name" :disabled="disabled_edit"></el-input>
                    </li>
                </ul>
                <ul>
                    <li>性别</li>
                    <li v-if="detailInfo.driverCardInfo">
                        <el-select placeholder="请选择" size="mini" v-model="detailInfo.driverCardInfo.sex" :disabled="disabled_edit" filterable @change="$forceUpdate()">
                            <el-option v-for="item in sexTypeLists" :key="`${item.id}_xb`" :label="item.label" :value="item.id"></el-option>
                        </el-select>
                    </li>
                </ul>
                <ul>
                    <li>准驾车型</li>
                    <li v-if="detailInfo.driverCardInfo">
                        <!-- <el-input placeholder="请输入" size="mini" v-model="detailInfo.driverCardInfo.className" :disabled="disabled_edit"></el-input> -->
                        <el-select placeholder="请选择" size="mini" v-model="moreCarClass" :disabled="disabled_edit" multiple filterable @change="$forceUpdate()">
                            <el-option v-for="item in tempList.driList" :key="item.CODE" :label="item.CODE" :value="`${item.id}`"></el-option>
                        </el-select>
                    </li>
                </ul>
                <ul>
                    <li>驾驶证号</li>
                    <li v-if="detailInfo.driverCardInfo">
                        <el-input placeholder="请输入" size="mini" v-model="detailInfo.driverCardInfo.driverCardNo" :disabled="disabled_edit"></el-input>
                    </li>
                </ul>
                <ul>
                    <li>地址</li>
                    <li v-if="detailInfo.driverCardInfo">
                        <el-input placeholder="请输入" type="textarea" :rows="3" size="mini" v-model="detailInfo.driverCardInfo.address" :disabled="disabled_edit"></el-input>
                    </li>
                </ul>
                <!-- <ul>
                    <li>驾驶证注册时间</li>
                    <li v-if="rowItem.driverCardTime">
                        <el-input placeholder="请输入" size="mini" v-model="rowItem.driverCardTime" :disabled="disabled_edit"></el-input>
                    </li>
                </ul> -->
            </div>
            <div class="detail_item">
                <b>身份证</b>
                <ul>
                    <li>姓名</li>
                    <li v-if="detailInfo.idCardInfo">
                        <el-input placeholder="请输入" size="mini" v-model="detailInfo.idCardInfo.name" :disabled="disabled_edit"></el-input>
                    </li>
                </ul>
                <ul>
                    <li>性别</li>
                    <li v-if="detailInfo.idCardInfo">
                        <el-select placeholder="请选择" size="mini" v-model="detailInfo.idCardInfo.sex" :disabled="disabled_edit" filterable @change="$forceUpdate()">
                            <el-option v-for="item in sexTypeLists" :key="`${item.id}_xb2`" :label="item.label" :value="item.id"></el-option>
                        </el-select>
                    </li>
                </ul>
                <ul>
                    <li>民族</li>
                    <li v-if="detailInfo.idCardInfo">
                        <el-input placeholder="请输入" size="mini" v-model="detailInfo.idCardInfo.nation" :disabled="disabled_edit"></el-input>
                    </li>
                </ul>
                <ul>
                    <li>出生日期</li>
                    <li v-if="detailInfo.idCardInfo">
                        <el-input placeholder="请输入" size="mini" v-model="detailInfo.idCardInfo.birthday" :disabled="disabled_edit"></el-input>
                    </li>
                </ul>
                <ul>
                    <li>身份证号</li>
                    <li v-if="detailInfo.idCardInfo">
                        <el-input placeholder="请输入" size="mini" v-model="detailInfo.idCardInfo.idNum" :disabled="disabled_edit"></el-input>
                    </li>
                </ul>
            </div>
            <div class="detail_item">
                <b>行驶证</b>
                <ul>
                    <li>姓名</li>
                    <li v-if="detailInfo.vehicleCardInfo">
                        <el-input placeholder="请输入" size="mini" v-model="detailInfo.vehicleCardInfo.owner" :disabled="disabled_edit"></el-input>
                    </li>
                </ul>
                <ul>
                    <li>车牌号码</li>
                    <li v-if="detailInfo.vehicleCardInfo">
                        <el-input placeholder="请输入" size="mini" v-model="detailInfo.vehicleCardInfo.plateNo" :disabled="disabled_edit"></el-input>
                    </li>
                </ul>
                <!-- <ul>
                    <li>行驶证号</li>
                    <li v-if="detailInfo.vehicleCardInfo">
                        <el-input placeholder="请输入" size="mini" v-model="detailInfo.vehicleCardInfo.aaa" :disabled="disabled_edit"></el-input>
                    </li>
                </ul> -->
                <ul>
                    <li>车辆识别代码</li>
                    <li v-if="detailInfo.vehicleCardInfo">
                        <el-input placeholder="请输入" size="mini" v-model="detailInfo.vehicleCardInfo.vin" :disabled="disabled_edit"></el-input>
                    </li>
                </ul>
                <!-- <ul>
                    <li>行驶证注册时间</li>
                    <li v-if="rowItem.vehicleCardTime">
                        <el-input placeholder="请输入" size="mini" v-model="rowItem.vehicleCardTime" :disabled="disabled_edit"></el-input>
                    </li>
                </ul> -->
            </div>
        </div>
        <div class="retrun_case">
            <span v-for="(item, index) in detailInfo.evidences" :key="index">
                <el-image class="retrun_image" fit="contain" lazy v-if="item.url.indexOf('.mp4') == -1" :src="getImageUrl(item.url)" @click="previewImg(item.url)"></el-image>
                <img class="retrun_image" fit="contain" lazy v-else src="../../../assets/images/pics/player.png" @click="previewImg(item.url)" />
            </span>
        </div>
        <!-- <div class="retrun_case" v-else>
            <img class="retrun_image" v-if="detailInfo.threeCardImage" :src="getImageUrl(detailInfo.threeCardImage)" @click="previewImg(detailInfo.threeCardImage)" >
            <img class="retrun_image" v-if="detailInfo.backIdCardImage" :src="getImageUrl(detailInfo.backIdCardImage)" @click="previewImg(detailInfo.backIdCardImage)" >
            <img class="retrun_image" v-if="detailInfo.backDriverImage" :src="getImageUrl(detailInfo.backDriverImage)" @click="previewImg(detailInfo.backDriverImage)" >
            <img class="retrun_image" v-if="detailInfo.halfBodyPhoto" :src="getImageUrl(detailInfo.halfBodyPhoto)" @click="previewImg(detailInfo.halfBodyPhoto)" >
        </div> -->

        <div style="text-align: center;">
            <el-button @click="onClose">关闭</el-button>
            <el-button type="primary" v-if="!disabled_edit" @click="onSave">保存</el-button>
            <el-button type="primary" @click="onNext">进入处理</el-button>
            <el-button type="primary" @click="onCancel">取消预约</el-button>
            <el-button type="primary" @click="onAppointmentSuccess">预约成功</el-button>
        </div>

        <el-dialog title="取消预约原因" center="" :visible.sync="dialogFormVisible" :close-on-click-modal="false" :append-to-body="true">
            <el-select style="width: 100%; margin-bottom: 20px;" placeholder="请选择取消预约类型" size="mini" v-model="reason" @change="onSelect">
                <el-option v-for="item in typeLists" :key="`${item.id}`" :label="item.label" :value="item.label"></el-option>
            </el-select>
            <el-input  placeholder="请填写取消预约原因" type="textarea" :rows="5" v-model="remark"></el-input>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取消</el-button>
                <el-button type="primary" @click="onConfirm">确定</el-button>
            </div>
        </el-dialog>


    </div>
</template>

<script>
import config from "@/common/env.js"
import tempList from "../json/index.js"

export default {
    props: ["roomId", "rowItem"],
    data() {
        return {
            tempList: tempList,
            sexTypeLists: [
                {id: "1", label: "男"},
                {id: "0", label: "女"},
            ],
            typeLists: [
                {id: "1", label: "行驶证核验未通过"},
                {id: "2", label: "身份证核验未通过"},
                {id: "3", label: "驾驶证核验未通过"},
                // {id: "4", label: "案件类型不符合"},
                {id: "5", label: "案件类型不符，请选择简易程序"},
                {id: "6", label: "案件类型不符，请选择一般程序"},
                {id: "7", label: "违法处理人与实际违法人不符"},
                {id: "8", label: "此车辆未发现有交通违法行为"},
                {id: "9", label: "其他"},
            ],
            disabled_edit: false,
            detailInfo: {},
            dialogFormVisible: false,
            reason: null,
            remark: null,
            moreCarClass: [],

        }
    },
    created() {
        console.log(this.rowItem)
        this.disabled_edit = this.rowItem && this.rowItem.status && this.rowItem.status < 3 ? false : true;

    },
    mounted() {
        this.getNewDetail();
    },
    methods: {
        // 详情
        getNewDetail() {
            this.$axios.get(`/admin/appointment/view/detail/${this.roomId}`).then(res => {
                let datas = this.AppUtils.checkResponse(res);
                let { code, data } = datas;
                if (code == 0) {
                    this.detailInfo = Object.assign({}, this.detailInfo, data);
                    if(this.detailInfo.driverCardInfo && this.detailInfo.driverCardInfo.classId) {
                        let str = this.detailInfo.driverCardInfo.classId;
                        this.moreCarClass = str.split(",");
					}
                }
            })
        },

        onClose() {
            this.$emit("onClose", {state: false});
        },

        onSelect(e) {
            console.log(e)
            if(e == "案件类型不符合") {
                this.remark = "预约案件类型不符合，退回重新预约";
            } else {
                this.remark = null;
            }
        },

        onSave() {
            console.log(this.detailInfo)
            let driverCardInfo = this.detailInfo.driverCardInfo;
            let idCardInfo = this.detailInfo.idCardInfo;
            let vehicleCardInfo = this.detailInfo.vehicleCardInfo;
            driverCardInfo.classId = this.moreCarClass.join(",");

            this.$axios.post(`/admin/appointment/save/detail`, {
                recordId: this.roomId,
                driverCardInfo,
                idCardInfo,
                vehicleCardInfo
            }).then(res => {
                let datas = this.AppUtils.checkResponse(res);
                let { code, data, msg } = datas;
                if(code == 0) {
                    this.dialogFormVisible = false;
                    this.$message.success("保存成功");
                } else {
                    this.$message.error(msg);
                }
            })
        },

        onAppointmentSuccess(){
            this.$axios.get(`/admin/appointment/sendSuccess/`+this.roomId).then(res => {
                let datas = this.AppUtils.checkResponse(res);
                let { code, data, msg } = datas;
                if(code == 0) {
                    // this.dialogFormVisible = false;
                    this.$message.success("操作成功");
                } else {
                    this.$message.error(msg);
                }
            })
        },
        // 取消预约
        onCancel() {
            this.reason = null;
            this.remark = null;
            this.dialogFormVisible = true;
        },
        onConfirm() {
            if(this.reason == null) {
                return this.$message.error("请选择取消预约类型")
            } else if(this.remark == null) {
                return this.$message.error("请填写取消预约原因")
            }
            this.$axios.post(`/admin/appointment/cancel`, {
                recordId: this.roomId,
                reason: this.reason,
                remark: this.remark
            }).then(res => {
                let datas = this.AppUtils.checkResponse(res);
                let { code, data, msg } = datas;
                if(code == 0) {
                    this.dialogFormVisible = false;
                    this.$message.success("取消预约成功");
                    this.$emit("onClose", {state: false, send: true});
                } else {
                    this.$message.error(msg);
                }
            })
        },

        onNext() {
            this.$emit("onClose", {state: false, next: true});
        },

        previewImg(url) {
            let data = [];
            if(this.rowItem.type == 2) {
                this.detailInfo.evidences.forEach(item => {
                    data.push(item.url)
                })
                // data = this.detailInfo.evidences;
            } else {
                data = [this.detailInfo.threeCardImage, this.detailInfo.backIdCardImage, this.detailInfo.backDriverImage];
                if(this.detailInfo.halfBodyPhoto) data.push(this.detailInfo.halfBodyPhoto);
            }
            data = Array.from(new Set(data));
            let index = data.findIndex(item => item == url);
            let _this = this;
            if (this.$store.state.previewImgUrl) {
                this.$store.commit("SHOW_PREVIEW_IMG", '')
            }
            setTimeout(() => {
                if (index > -1) {
                    localStorage.setItem("myIndex", index);
                    localStorage.setItem("myPics", JSON.stringify(data));
                } else {
                    data.push(url);
                    localStorage.setItem("myIndex", data.length - 1);
                    localStorage.setItem("myPics", JSON.stringify(data));
                }
                localStorage.setItem("newDe", "");
                _this.$store.commit("SHOW_PREVIEW_IMG", url);
            }, 500)
        },
        getImageUrl(url, type) {
            let str = type ? "/file/server/file" : "/file/server/decrypt/file";
            return `${config.baseUrl}${str}?path=${encodeURI(url)}`;
        },

    }
}
</script>

<style lang="less" scoped>
    .title {
        width: 100%;
        margin-bottom: 20px;
        display: flex;
    }
    .title span {
        color: #ffa500;
    }
    .detail_case {
        width: 100%;
        display: flex;
    }
    .detail_case .detail_item {
        width: 30%;
        margin: 0 1.5%;
        flex: 1;
    }
    .detail_case .detail_item b {
        line-height: 35px;
        border-bottom: 1px solid #ccc;
        display: block;
    }
    .detail_case .detail_item ul {
        margin: 10px 0;
        display: flex;
    }
    .detail_case .detail_item ul li {
        width: 65%;
    }
    .detail_case .detail_item ul li:first-child {
        width: 35%;
    }
    .retrun_case {
        display: flex;
        flex-flow: wrap;
    }
    .retrun_image {
        // width: calc((100% - 60px) / 6);
        width: 100px;
		height: 100px;
        margin: 10px 5px;
        display: block;
        object-fit: contain;
        cursor: pointer;
    }

</style>



// WEBPACK FOOTER //
// detail.vue?22bc565c